import { inject } from "vue";
import { useListingArrayModel } from "./useListingArrayModel";
import { transformPackagedServicesToApi } from "../utils/transformers/servicesTransformers";
import type { PackagedService } from "../types/listingModels";
import { ListingPackagedServicesStoreKey } from "./listingStoreKeys";

export function createListingPackagedServicesStore() {
    const arrayModel = useListingArrayModel<PackagedService>();

    function getPublishable() {
        return transformPackagedServicesToApi(arrayModel.model.value);
    }

    return {
        model: arrayModel.model,
        initial: arrayModel.initial,
        isDirty: arrayModel.isDirty,
        add: arrayModel.add,
        updateAt: arrayModel.updateAt,
        removeAt: arrayModel.removeAt,
        reorder: arrayModel.reorder,
        markSaved: arrayModel.markSaved,
        resetAll: arrayModel.resetAll,
        getPublishable,
    };
}

export function useListingPackagedServicesStore() {
    const store = inject(ListingPackagedServicesStoreKey);
    if (!store) {
        throw new Error('useListingPackagedServicesStore must be used within a component that provides ListingPackagedServicesStoreKey');
    }
    return store;
}

